var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.7637 2C15.265 4.73835 16.6864 8.29203 16.7637 12C16.6864 15.708 15.265 19.2616 12.7637 22M12.7637 2C10.2624 4.73835 8.84092 8.29203 8.76367 12C8.84092 15.708 10.2624 19.2616 12.7637 22M12.7637 2C7.24082 2 2.76367 6.47715 2.76367 12C2.76367 17.5228 7.24082 22 12.7637 22M12.7637 2C18.2865 2 22.7637 6.47715 22.7637 12C22.7637 17.5228 18.2865 22 12.7637 22M3.26369 9H22.2637M3.26367 15H22.2637",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe02);
export default __webpack_public_path__ + "static/media/globe02.1272637e80494c22d3727787e2fca87b.svg";
export { ForwardRef as ReactComponent };